exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".addgallery[data-v-719cf1f0]{padding:20px 20px}\n", ""]);

// exports
